import React, { HTMLAttributes } from 'react'

import { cn } from '@/lib/ui/style-helpers'

import { RadioCard } from '@/components/lemmala-design-system/radio-card/radio-card'

export interface RadioCardOption<T> {
  value: T
  title: string
  description?: React.ReactNode
  titleBadge?: React.ReactNode
  titleSuffix?: React.ReactNode
}

export interface RadioCardsProps<T> extends Omit<
  HTMLAttributes<HTMLDivElement>,
  'onChange' | 'value'
> {
  options: RadioCardOption<T>[]
  value?: T
  onValueChange?: (value: T) => void
  showRadioButton?: boolean
}

export function RadioCards<T>({
  className,
  options,
  value,
  onValueChange,
  showRadioButton = true,
  ...props
}: RadioCardsProps<T>) {
  const handleSelect = (optionValue: T) => {
    onValueChange?.(optionValue)
  }

  return (
    <div className={cn('flex w-fit flex-col gap-2', className)} {...props}>
      {options.map((option) => {
        const isSelected = value === option.value

        return (
          <RadioCard
            key={String(option.value)}
            value={option.value}
            title={option.title}
            description={option.description}
            titleBadge={option.titleBadge}
            titleSuffix={option.titleSuffix}
            checked={isSelected}
            onSelect={handleSelect}
            showRadioButton={showRadioButton}
            className='transition-all duration-150'
          />
        )
      })}
    </div>
  )
}
